module.exports = __webpack_public_path__ + "img/img (57).6983545b.jpg";